import { render, staticRenderFns } from "./FooterRithual.vue?vue&type=template&id=2fa7a61a&scoped=true&"
import script from "./FooterRithual.vue?vue&type=script&lang=js&"
export * from "./FooterRithual.vue?vue&type=script&lang=js&"
import style0 from "./FooterRithual.vue?vue&type=style&index=0&id=2fa7a61a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa7a61a",
  null
  
)

export default component.exports